import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import axios from 'src/utils/axios';
import {
  Card,
  CardContent,
  Container,
  Dialog,
  DialogActions,
  DialogTitle,
  Divider,
  Grid,
  TextField,
  Button,
  Typography,
  FormControlLabel,
  Snackbar,
  Backdrop,
  DialogContent,
  ListItemText,
  ListItem,
  List,
  CardHeader,
  IconButton,
  Tooltip
} from '@material-ui/core';
import Page from 'src/components/Page';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import SearchIcon from '@material-ui/icons/Search';
import Checkbox from '@material-ui/core/Checkbox';
import { useTranslation } from 'react-i18next';
import SearchBar from 'material-ui-search-bar';
import EditIcon from '@material-ui/icons/Edit';
import CloseIcon from '@material-ui/icons/Close';
import SaveIcon from '@material-ui/icons/Save';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import Alert from 'src/components/Alert';
import moment from 'moment';
import CircularProgress from '@material-ui/core/CircularProgress';
// import WorkOrderDetailPage from 'src/views/Operation/WorkOrderDetail';
import ExcelExport from 'src/components/CustomerFeedbackExcelExport';
import { sc } from 'src/utils/Common';
import { getUser } from 'src/utils/Common';
import {maskStringData} from 'src/MaskData'


const useStyles = makeStyles((theme) => ({
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0)'
  },
  root: {
    paddingTop: theme.spacing(0),
    paddingBottom: theme.spacing(0)
  },
  cardscontent: {
    minHeight: 300,
  },
  tableRow: {
    '&$hover:hover': {
      backgroundColor: '#f5f5f5'
    }
  },
  tableCell: {
    '$hover:hover &': {
      color: 'black'
    }
  },
  hover: {},
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
  container: {
    maxHeight: 630,
  },
}));


function CustomerFeedback() {
  const classes = useStyles();
  const { t } = useTranslation('JobControl');
  const dispatch = useDispatch();
  // const serviceShopControl = useSelector((state) => state.jobControl.ServiceShopControl);
  // const jobOrderStatus = useSelector((state) => state.jobControl.JobOrderStatus);
  // const JobOrderLogicStatus = useSelector((state) => state.jobControl.JobOrderLogicStatus);
  // const rejectReason = useSelector((state) => state.jobControl.RejectReason);
  // const regionServiceControl = useSelector((state) => state.serviceShop.RegionServiceControl);
  // const subServiceShopControl = useSelector((state) => state.jobControl.ServiceShopControl);
  // const issueListSelector = useSelector((state) => state.issue.Issues);
  // const caseStatusListSelector = useSelector((state) => state.jobControl.CaseStatusList);

  const SessionUser = getUser();

 

  const [consumerInformation, setConsumerInformation] = useState([]);
  const [workOrderId, setWorkOrderId] = useState(0);
  const [workCaseId, setWorkCaseId] = useState(0);
  const [singleWorkOrderId, setSingleWorkOrderId] = useState(0);
  const [StatusLogicData, setStatusLogicData] = useState([]);
  const [reasonData, setReasonData] = useState([]);
  const [statusId, setStatusId] = useState(0);
  const [changeStatus, setChangeStatus] = useState();
  const [Loading, setLoading] = useState(false);
  const [PopUp, setPopUp] = useState(false);
  const [singlePopUp, setSinglePopUp] = useState(false);
  const [workOrderPopUp, setWorkOrderPopUp] = useState(false);
  const [checkedWorkCaseId, setCheckedWorkCaseId] = useState([])
  const [regionList, setRegionList] = useState([]);
  const [regionSelected, setRegionSelected] = useState('');
  const [subServiceShopList, setSubServiceShopList] = useState([]);
  const [serviceShopSelected, setServiceShopSelected] = useState('');
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [rejectDescription, setRejectDescription] = useState('');
  const [SnackbarOpen, setSnackbarOpen] = useState(false);
  const [issueList, setIssueList] = useState([]);
  const [selectedIssue, setSelectedIssue] = useState();
  const [caseStatusList, setCaseStatusList] = useState([]);
  const [caseStatusRuleList, setCaseStatusRuleList] = useState([]);
  const [selectedCaseStatus, setSelectedCaseStatus] = useState();
  const [workCaseFeedBacks, setWorkCaseFeedBacks] = useState([]);
  const [statusRuleData, setStatusRuleData] = useState([]);
  const [uyariTip, setUyariTip] = React.useState('default');
  const [responseMessage, setresponseMessage] = useState({
    ErrorCode: '0',
    ErrorDescription: t('success_message')
  });

  //SearchBar
  const [initialRows, setinitialRows] = useState([]);
  const [searched, setSearched] = useState('');

  const today = moment().format('DD-MM-YYYY');
  const oneYearAgo = moment().subtract(1, 'years').format('DD-MM-YYYY');
  const [Required, setRequired] = useState(false);
  const [RequiredForSearch, setRequiredForSearch] = useState(false);

   

  // const SaveIssue = (ids) => {
  //   if (!rejectDescription || !changeStatus) {
  //     setRequired(true);
  //     return
  //   }



  //   setPopUp(false);
  //   setSinglePopUp(false);
  //   confirmAlert({
  //     message: t('lblConfirm'),
  //     buttons: [
  //       {
  //         label: t('lblYes'),
  //         onClick: () => handleSaveIssue(ids)
  //       },
  //       {
  //         label: t('lblNo'),
  //         onClick: () => {
  //         }
  //       }
  //     ]
  //   });
  // };

  useEffect(() => {
    getSiriusCloseStatus();
    getCaseStatus();
    getRejectReason();
    getRegionForServiceShop();
    getIssues();
  }, [dispatch]);

  // useEffect(() => {
  //   setStatusLogicData(JobOrderLogicStatus);
  //   setStatusId(jobOrderStatus[0]);
  //   setReasonData(rejectReason);
  //   setIssueList(issueListSelector.filter((x) => x?.IssueTypeId !== 1));
  //   setCaseStatusList(caseStatusListSelector);
  // }, [serviceShopControl, jobOrderStatus, rejectReason, JobOrderLogicStatus, issueListSelector]);

  useEffect(() => {
    setinitialRows(consumerInformation);
  }, [consumerInformation]);

  async function changeRegion(region) {
    setRegionSelected(region);
    //dispatch(getServiceShopForRegion(region.RegionId));
  }

  function getSiriusCloseStatus() {
    axios
      .get('/GetSiriusCloseStatus')
      .then(response => {
        const Deger = response.data;
        if (Deger.length > 0) {
          setStatusId(Deger);
        }
        setLoading(false);
      })
      .catch(error => {
        setStatusId([]);
        setLoading(false);
      });
  }

  function getCaseStatus() {
    axios
      .get('/GetCaseStatus')
      .then(response => {
        const Deger = response.data;
        if (Deger.length > 0) {
          setCaseStatusList(Deger);
        }
        setLoading(false);
      })
      .catch(error => {
        setCaseStatusList([]);
        setLoading(false);
      });
  }

  function getRejectReason() {
    axios
      .get('/GetRejectReasonJobControl')
      .then(response => {
        const Deger = response.data;
        if (Deger.length > 0) {
          setReasonData(Deger);
        }
        setLoading(false);
      })
      .catch(error => {
        setReasonData([]);
        setLoading(false);
      });
  }

  function getRegionForServiceShop() {
    axios
      .get('/GetRegionForServiceShop')
      .then(response => {
        const Deger = response.data;
        if (Deger.length > 0) {
          setRegionList(Deger);
        }
        setLoading(false);
      })
      .catch(error => {
        setRegionList([]);
        setLoading(false);
      });

  }

  function getIssues() {
    axios
      .get('/GetIssuesForCustomerFeedback')
      .then(response => {
        const Deger = response.data;
        if (Deger.length > 0) {
          setIssueList(Deger);
        }
        setLoading(false);
      })
      .catch(error => {
        setIssueList([]);
        setLoading(false);
      });
  }


  const cancelSearch = () => {
    setSearched('');
    requestSearch(searched);
  };


  const requestSearch = (searchedVal) => {
    const filteredRows = consumerInformation.filter((item) => sc(
      item.WorkCaseId + item.ReceiptNo + item.Technician + item.Status + item.SourceServiceShopCode
      + item.ServiceShopName + item.ContactName + item.ModelCode + item.Model + item.OpenDate + item.CreateUser
      + item.UpdateUser,
      searchedVal
    ));
    setinitialRows(filteredRows);
  };

  async function searchWorkOrder() {
    setConsumerInformation([]);
    setLoading(true);
    if (workCaseId === '0' || workCaseId === '' || workCaseId === 0) {
      if (regionSelected === null || selectedIssue?.Id === undefined || selectedCaseStatus?.Id === undefined) {
        setresponseMessage({
          ErrorCode: 10,
          ErrorDescription: t('lblMustFieldControl')
        });
        setUyariTip('error');
        setSnackbarOpen(true);
        setRequiredForSearch(true);
        setLoading(false);
        return;
      } else {
        // const temp = [selectedIssue?.Id || 0, selectedCaseStatus?.Id || 0, oneYearAgo.toString(), today.toString()];
        var requestStr = '/GetTasksDataByIssueForCustomerFeedBack/' + selectedIssue?.Id + '/' + selectedCaseStatus?.Id + '/' + oneYearAgo.toString() + '/' + today.toString()
        axios
          .get(requestStr)
          .then(response => {
            const Deger = response.data;
            if (Deger.length > 0) {
              setConsumerInformation(Deger.map((w) => ({
                WorkCaseId: w.WorkCaseId,
                ReceiptNo: w.id,
                Technician: w.Technician,
                Status: w.Status,
                SourceServiceShopCode: w.ServiceCode,
                ServiceShopName: w.ServiceShop,
                ContactName: w.Consumer[0].Search,
                ModelCode: w.ProductCode,
                Model: w.Product,
                OpenDate: w.OpenDate,
                CreateUser: w.CreateUser,
                UpdateUser: w.UpdateUser,
                StatusId: w.StatusId,
                FeedbackDescription: w.FeedbackDescription,
                UpdateDate: w.UpdateDate
              })));
            }
            setLoading(false);
          })
          .catch(error => {
            setConsumerInformation([]);
            setLoading(false);
          });
      }
    } if (workCaseId > 0) {
      axios
      .get('/GetConsumerFeedback/' + workCaseId)
      .then(response => {
        const Deger = response.data;
        if (Deger.length > 0) {
          setConsumerInformation(Deger.map((a) => ({
            WorkCaseId: a.WorkCaseId,
            ReceiptNo: a.ReceiptNo,
            Technician: a.Technician,
            Status: a.Status,
            SourceServiceShopCode: a.SourceServiceShopCode,
            ServiceShopName: a.ServiceShopName,
            ContactName: a.ContactName,
            ModelCode: a.ModelCode,
            Model: a.Model,
            OpenDate: a.OpenDate,
            CreateUser: a.CreateUser,
            UpdateUser: a.UpdateUser,
            StatusId: a.StatusId,
            FeedbackDescription: a.FeedbackDescription,
            UpdateDate: a.UpdateDate
          })));
        }
        setLoading(false);
      })
      .catch(error => {
        setConsumerInformation([]);
        setLoading(false);
      });
    }
  }

  const setWorkOrderPopUpParam = (WorkOrderId) => {
    setWorkOrderId(WorkOrderId);
    setWorkOrderPopUp(true);
    setSelectedIndex(WorkOrderId);
    setSingleWorkOrderId(WorkOrderId);

  };

  // const handleSaveIssue = (ids) => {
  //   const dict = {
  //     Ids: ids,
  //     StatusId: changeStatus.Id,
  //     RejectDescription: rejectDescription,
  //     EmployeeId: SessionUser.TechnicianId,
  //     Status: changeStatus.FieldText
  //   };
  //   setChangeStatus('')
  //   dispatch(setTaskStatusByIssue(dict));
  //   searchWorkOrder();
  //   setRejectDescription();
  //   setCheckedWorkCaseId([]);
  //   setSnackbarOpen(true);
  //   setresponseMessage({
  //     ErrorCode: 10,
  //     ErrorDescription: t('lblSuccessfulOperation')
  //   });
  //   setUyariTip('success');


  // };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
  };


  // const SetOpenSinglePage = (row) => {
  //   setWorkCaseFeedBacks([])
  //   dispatch(getWorkCaseFeedbacks(row.WorkCaseId)).then(response => {
  //     setWorkCaseFeedBacks(response.payload)
  //   })
  //   setRequired(false);
  //   setSingleWorkOrderId(row.WorkCaseId);
  //   setSelectedIndex(row.ReceiptNo);
  //   setRejectDescription('')
  //   setSinglePopUp(true);
  //   setChangeStatus([]);
  // }

  // const SetPopupAcceptRejectPage = () => {
  //   setWorkCaseFeedBacks([])
  //   dispatch(getWorkCaseFeedbacks(initialRows[0]?.WorkCaseId)).then(response => {
  //     setWorkCaseFeedBacks(response.payload)
  //   })
  //   setRejectDescription('')
  //   setRequired(false);
  //   setPopUp(true);
  //   setChangeStatus([]);
  // }


  if (SessionUser?.ServiceShopId === 11740){
    return <div />;
  }

  return (
    <>
      <Page title="">
        <Backdrop className={classes.backdrop} open={Loading}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <Container maxWidth="xl" spacing={1} className={classes.root}>
          <Card>
            <CardContent>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={4} lg={3}>
                  <Autocomplete
                    size="small"
                    fullWidth
                    autoSelect
                    disableClearable
                    value={regionSelected || null}
                    options={regionList || []}
                    getOptionLabel={(option) => (option.Dsc ? option.Dsc : '')}
                    getOptionSelected={(option, value) => option.RegionId === value.RegionId}
                    renderInput={(params) => <TextField {...params} label={t('lblRegion')} variant="outlined"
                      error={regionSelected === null ? RequiredForSearch : false}
                    />}
                    onChange={(event, value) => { changeRegion(value); }}
                  />
                </Grid>
                <Grid item xs={12} sm={4} lg={3}>
                  <Autocomplete
                    size="small"
                    fullWidth
                    autoSelect
                    disableClearable
                    value={selectedIssue || null}
                    options={issueList?.filter(x => x?.IssueTypeId === 3 || x?.IssueTypeId === 4 || x?.IssueTypeId === 5 || x?.IssueTypeId === 13) || []}
                    getOptionLabel={(option) => (option.YourLanguageDescription ? option.YourLanguageDescription : '')}
                    getOptionSelected={(option, value) => option.Id === value.Id}
                    renderInput={(params) => <TextField {...params} label={t('lblReason')} variant="outlined"
                      error={selectedIssue?.Id > 0 ? false : RequiredForSearch}
                    />}
                    onChange={(event, value) => {
                      setSelectedIssue(value);
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={2}>
                  <Autocomplete
                    size="small"
                    fullWidth
                    autoSelect
                    disableClearable
                    value={selectedCaseStatus || []}
                    options={caseStatusList || []}
                    getOptionLabel={(option) => (option?.FieldText ? option?.FieldText : '')}
                    getOptionSelected={(option, value) => option?.Id === value?.Id}
                    renderInput={(params) => <TextField {...params} label={t('lblStatus')} variant="outlined"
                      error={selectedCaseStatus?.Id > 0 ? false : RequiredForSearch}
                    />}
                    onChange={(event, value) => {
                      setSelectedCaseStatus(value);
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={1} lg={1}>
                  <TextField
                    size="small"
                    fullWidth
                    label={t('lblWorkCaseId')}
                    type="number"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={workCaseId}
                    onChange={(event) => setWorkCaseId(event.target.value)}
                    id="Status"
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={12} sm={2} lg={2}>
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    fullWidth
                    onClick={() => searchWorkOrder()}
                    endIcon={<SearchIcon />}
                  >
                    {t('lblSearch')}
                  </Button>
                </Grid>
                <Grid item xs={12} sm={1} lg={1}>
                  <ExcelExport JsonData={initialRows} title={t('lblExport')} />
                </Grid>
              </Grid>
            </CardContent>
            <CardContent>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={2} lg={8}>
                </Grid>
                <Grid item xs={12} sm={2} lg={4}>
                  <SearchBar
                    value={searched}
                    onChange={searchVal => requestSearch(searchVal)}
                    onCancelSearch={() => cancelSearch()}
                    placeholder={t('lblSearch')}
                    style={{ margin: '0 auto', maxWidth: 800, maxHeight: 37 }}
                  />
                </Grid>
              </Grid>
              <br />
              <TableContainer className={classes.container}>
                <Table stickyHeader aria-label="sticky table" size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell align="left" />
                      <TableCell align="left">{t('lblWorkCaseId').replace(' ', '')}</TableCell>
                      <TableCell align="left">{t('lblStatus')}</TableCell>
                      <TableCell align="left">{t('lblCustomer')}</TableCell>
                      <TableCell align="left">{t('lblFeedbackDescription')}</TableCell>
                      <TableCell align="left">{t('lblOpenDate').replace(' ', '')}</TableCell>
                      <TableCell align="left">{t('lblUpdateUser')}</TableCell>
                      <TableCell align="left">{t('lblUpdateDate').replace(' ', '')}</TableCell>
                      <TableCell align="left" />
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {initialRows.map((row, index) => (
                      <TableRow key={index}
                        style={checkedWorkCaseId.length > 0 ? row.ReceiptNo === selectedIndex ? { backgroundColor: "#D1E2E8" } : {} : {}}>
                        <TableCell>
                          {/* <FormControlLabel
                            value="top"
                            control={(
                              <Checkbox
                                color="primary"
                                checked={checkedWorkCaseId.includes(row.WorkCaseId) ? true : false}
                                onChange={() => {
                                  setSelectedIndex(row.ReceiptNo)
                                  if (checkedWorkCaseId.includes(row.WorkCaseId)) {
                                    setCheckedWorkCaseId(checkedWorkCaseId.filter((item) => item !== row.WorkCaseId));
                                  } else {
                                    setCheckedWorkCaseId([...checkedWorkCaseId, row.WorkCaseId]);
                                  }
                                }}
                              />
                            )}
                          /> */}

                        </TableCell>
                        <TableCell align="left">{row.WorkCaseId}</TableCell>
                        <TableCell align="left">{row.Status}</TableCell>
                        <TableCell align="left">{maskStringData(row.ContactName)}</TableCell>
                        <TableCell align="left">{row.FeedbackDescription}</TableCell>
                        <TableCell align="left">{moment(row.OpenDate).format('DD.MM.YYYY HH:mm')}</TableCell>
                        <TableCell align="left">{row.UpdateUser}</TableCell>
                        <TableCell align="left">{row.UpdateDate === undefined ? '' : moment(row.UpdateDate).format('DD.MM.YYYY HH:mm')}</TableCell>
                        {/* <TableCell align="left">
                          <IconButton
                            size="small"
                            onClick={() => SetOpenSinglePage(row)}
                            style={selectedIndex === row.ReceiptNo ? { backgroundColor: '#CC0000', color: 'white' } : {}}
                          >
                            <EditIcon />
                          </IconButton>
                        </TableCell> */}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </CardContent>
            <DialogActions>
              <Grid item xs={12} sm={2} lg={2}>
                {/* <Tooltip title="Act on selected checkboxes">
                  <Button
                    disabled={checkedWorkCaseId.length === 0}
                    variant="contained"
                    color="primary"
                    size="small"
                    fullWidth
                    onClick={() => SetPopupAcceptRejectPage()}
                    endIcon={<EditIcon />}
                  >
                    {t('lblOperation')}
                  </Button>
                </Tooltip> */}
              </Grid>
            </DialogActions>
          </Card>
        </Container>
        <Dialog
          open={workOrderPopUp}
          fullWidth
          maxWidth="xl"
          onClose={() => setWorkOrderPopUp(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle
            id="alert-dialog-title"
            style={{ textAlign: 'center' }}
          >
            {t('lblWorkOrderDetail')}
          </DialogTitle>
          {/* <DialogContent>
            <WorkOrderDetailPage WorkOrderId={workOrderId} />
          </DialogContent> */}
          <DialogActions>
            <Button
              color="primary"
              onClick={() => {
                setWorkOrderPopUp(false)
              }}
              aria-label="close"
              component="span"
              variant="contained"
              endIcon={<CloseIcon />}
            >
              {' '}
              {t('lblClose')}
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={PopUp}
          fullWidth
          maxWidth="xl"
          onClose={() => setPopUp(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle
            id="alert-dialog-title"
            style={{ textAlign: 'center' }}
          >
            {consumerInformation[0]?.ContactName}
          </DialogTitle>
          <Container maxWidth="xl" spacing={1}>
            <Divider />
            <Card>
              <CardHeader title={`${t('lblWorkCaseId')}:  ${checkedWorkCaseId?.join(', ')}`} />
              <Divider />
              <CardContent className={classes.cardscontent}>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={12} lg={12}>
                    <Autocomplete
                      size="small"
                      fullWidth
                      autoSelect
                      disableClearable
                      value={changeStatus || []}
                      options={caseStatusList}
                      getOptionLabel={(option) => (option.FieldText ? option.FieldText : '')}
                      getOptionSelected={(option, value) => option.StatusId === value.StatusId}
                      renderInput={(params) => <TextField {...params} label={t('lblStatus')} variant="outlined"
                        error={changeStatus.StatusId > 0 ? false : Required} />}
                      onChange={(event, value) => {
                        setChangeStatus(value);
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} lg={12}>
                    <TextField
                      size="small"
                      id="Description"
                      multiline
                      rows={5}
                      autoComplete="no"
                      fullWidth
                      error={rejectDescription?.length > 0 ? false : Required}
                      label={t('lblDescription')}
                      variant="outlined"
                      value={rejectDescription}
                      onChange={(event) => setRejectDescription(
                        event.target.value
                      )}
                    />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
            <Divider />
          </Container>
          <DialogActions>
            {/* <Button
              color="primary"
              onClick={() => SaveIssue(checkedWorkCaseId)}
              aria-label="save"
              component="span"
              variant="contained"
              endIcon={<SaveIcon />}
            >
              {' '}
              {t('lblSave')}
            </Button> */}
            <Button
              color="primary"
              onClick={() => {
                setPopUp(false)
                setCheckedWorkCaseId([])
              }}
              aria-label="close"
              component="span"
              variant="contained"
              endIcon={<CloseIcon />}
            >
              {' '}
              {t('lblClose')}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={singlePopUp}
          fullWidth
          maxWidth="sm"
          onClose={() => setSinglePopUp(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle
            id="alert-dialog-title"
            style={{ textAlign: 'center' }}
          >
            {' '}
            {consumerInformation[0]?.ContactName}
          </DialogTitle>
          <Container maxWidth="sm" spacing={1}>
            <Divider />
            <Card>
              <CardHeader title={`${t('lblWorkCaseId')}: ${singleWorkOrderId}`} />
              <Divider />

              <List className={classes.root}>
                {workCaseFeedBacks.map((row, index) => (
                  <>
                    <ListItem key={row.index} alignItems="flex-start">
                      <ListItemText
                        primary={row.Owner}
                        secondary={
                          <React.Fragment>
                            <Typography
                              component="span"
                              variant="body2"
                              className={classes.inline}
                              color="textPrimary"
                            >
                              {row.Status + ' — ' + row.Reply}
                            </Typography>
                            {' — ' + row.CreateDate}
                          </React.Fragment>
                        }
                      />
                    </ListItem>
                    <Divider variant="middle" component="li" />
                  </>
                ))}


              </List>

              <CardContent className={classes.cardscontent}>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={12} lg={12}>
                    <Autocomplete
                      size="small"
                      fullWidth
                      autoSelect
                      disableClearable
                      value={changeStatus || 0}
                      options={caseStatusList}
                      getOptionLabel={(option) => (option.FieldText ? option.FieldText : '')}
                      getOptionSelected={(option, value) => option.StatusId === value.StatusId}
                      renderInput={(params) => <TextField {...params} label={t('lblStatus')}
                        error={changeStatus?.FieldText ? false : Required} variant="outlined" />}
                      onChange={(event, value) => {
                        setChangeStatus(value);
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} lg={12}>
                    <TextField
                      size="small"
                      id="desc"
                      autoComplete="no"
                      multiline
                      error={rejectDescription?.length > 0 ? false : Required}
                      rows={10}
                      value={rejectDescription}
                      onChange={(event) => setRejectDescription(
                        event.target.value
                      )}
                      fullWidth
                      label={t('lblDescription')}
                      variant="outlined"
                    />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
            <Divider />
          </Container>
          <DialogActions>
            {/* <Button
              color="primary"
              onClick={() => SaveIssue([singleWorkOrderId])}
              aria-label="save"
              component="span"
              variant="contained"
              endIcon={<SaveIcon />}
            >
              {' '}
              {t('lblSave')}
            </Button> */}
            <Button
              color="primary"
              onClick={() => setSinglePopUp(false)}
              aria-label="close"
              component="span"
              variant="contained"
              endIcon={<CloseIcon />}
            >
              {' '}
              {t('lblClose')}
            </Button>
          </DialogActions>
        </Dialog>
        <Snackbar open={SnackbarOpen} autoHideDuration={10000} onClose={handleClose}>
          <Alert
            onClose={handleClose}
            message={responseMessage.ErrorDescription}
            variant={uyariTip}
          />
        </Snackbar>
      </Page>
    </>
  );
}

export default CustomerFeedback;
